// product grid/list
function listgridJavascript() {
Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', function(event) {
        Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
        this.classList.add('active');
        if(this.classList.contains('listv')){
            document.getElementById('product-grid').classList.add('product-list');
            document.getElementById('product-grid').classList.remove('product-grid');
        }else if(this.classList.contains('gridv')){
            document.getElementById('product-grid').classList.add('product-grid');
            document.getElementById('product-grid').classList.remove('product-list');
        }
    });
});
};
document.addEventListener("shopify:section:load", listgridJavascript);
listgridJavascript();


// on scroll play video

window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

/*
class QuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.previousQtyValue = 0;
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  //connectedCallback() {
  //  this.variantIdChangedUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
  //    this.previousQtyValue = 0;
  //    console.log(this.previousQtyValue);
  //  });
  //}

  onInputChange(event) {
    this.validateQtyRules();
    const quantity = this.input.value;
    const variantId = this.input.dataset.quantityVariantId;
    //console.log(this.previousQtyValue);
    this.querySelector('.loading-overlay').classList.remove('hidden');
    if (this.previousQtyValue == 0 && quantity == 1) {
      this.addProduct(quantity, variantId);
    } else {
      this.updateQuantity(quantity, variantId);
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    this.previousQtyValue = this.input.value;
    const previousValue = this.input.value;
    
    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) < parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }

  addProduct(quantity, variantId) {
    const body = JSON.stringify({
      id: variantId,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    
    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => response.json())
        .then((response) => {
          publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: variantId});
          this.cart.renderContents(response, false);
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.querySelector('.loading-overlay').classList.add('hidden');
        });
  }

  updateQuantity(quantity, variantId) {
    const body = JSON.stringify({
      id: variantId,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then(async (state) => {
        const parsedState = JSON.parse(state);
        const line = parsedState?.items.findIndex(item => item.variant_id == variantId, variantId) + 1;

        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        //this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items', cartData: parsedState, variantId: variantId});

        this.querySelector('.loading-overlay').classList.add('hidden');
        
        // update quantity input
        //if (parsedState.items_removed.length > 0) {
        //  let updatedProductId = parsedState.items_removed[0].product_id;
        //  let updatedProduct = parsedState.items.find((product) => product.product_id == updatedProductId);
        //  if (updatedProduct) {
        //    document.dispatchEvent(new CustomEvent("product:quantity:update", { bubbles: true, detail: { product: updatedProduct } }));
        //  } else {
        //    document.dispatchEvent(new CustomEvent("product:quantity:update", { bubbles: true, detail: { product: {product_id: updatedProductId, quantity: 0, handle: parsedState.items_removed[0].url} } }));
        //  }
        //} else {
        //  this.classList.remove("has-delete-item-button");
        //}
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}
customElements.define('quantity-selector', QuantitySelector);*/

class QuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.previousQtyValue = 0;
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.cart =
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer');

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  connectedCallback() {
    // Subscribe to variant change event
    this.variantIdChangedUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      (event) => {
        const variant = event.data?.variant;
        if (!variant) return;
        
        // Reset quantity tracker when variant changes
        this.previousQtyValue = 0;
        
        // Optional: Reset input UI
        if (this.input) {
          this.input.value = 0;
          this.validateQtyRules();
        }

        console.log('Variant changed → reset qty value:', this.previousQtyValue);
      }
    );
  }

  disconnectedCallback() {
    // Cleanup subscription to prevent memory leaks
    if (this.variantIdChangedUnsubscriber) {
      this.variantIdChangedUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();

    const quantity = parseInt(this.input.value, 10);
    const variantId = this.input.dataset.quantityVariantId;

    this.querySelector('.loading-overlay').classList.remove('hidden');
    
    // If quantity starts from zero → add new product
    if (this.previousQtyValue === 0 && quantity === 1) {
      this.addProduct(quantity, variantId);
    } else {
      this.updateQuantity(quantity, variantId);
    }

    // Always update the last known value
    this.previousQtyValue = quantity;
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = parseInt(this.input.value, 10);
    this.previousQtyValue = previousValue;

    if (event.target.name === 'plus') {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== parseInt(this.input.value, 10)) {
      this.input.dispatchEvent(this.changeEvent);
    }

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }

  addProduct(quantity, variantId) {
    const body = JSON.stringify({
      id: variantId,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((response) => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: variantId,
        });
        this.cart.renderContents(response, false);
        if (this.cart && this.cart.classList.contains('is-empty')) {
          this.cart.classList.remove('is-empty');
        }
        this.querySelector('.loading-overlay').classList.add('hidden');
      });
  }

  updateQuantity(quantity, variantId) {
    const body = JSON.stringify({
      id: variantId,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        const line =
          parsedState?.items.findIndex(
            (item) => item.variant_id == variantId
          ) + 1;

        if (parsedState.errors) return;

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter)
          cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            'is-empty',
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-items',
          cartData: parsedState,
          variantId: variantId,
        });

        this.querySelector('.loading-overlay').classList.add('hidden');
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}
customElements.define('quantity-selector', QuantitySelector);


document.addEventListener("product:added", (event) => {
  //document.dispatchEvent(new CustomEvent("product:quantity:update", { bubbles: true, detail: { product: event.detail.product } }));
});

document.addEventListener("product:quantity:update", (event) => {
  const quickAddEl = document.querySelectorAll(".product-form-with-quantity");
  if (quickAddEl) {
    const product = event.detail.product;
    quickAddEl.forEach((item) => {
      if (item.hasAttribute("data-product-id") && item.getAttribute("data-product-id") == product?.product_id) {
        if (event.detail.added) {
          item.querySelector(`.quantity__input`).value = product.quantity;
        } else {
          item.querySelector(`.quantity__input`).value = ((product.quantity == 1) ? 0 : product.quantity);
        }
        /*if (product.quantity > 0) {
          item.querySelector("product-form").classList.add("hidden");
          item.querySelector("quantity-selector").classList.remove("hidden");
        } else {
          item.querySelector("product-form").classList.remove("hidden");
          item.querySelector("quantity-selector").classList.add("hidden");
        }*/
      } else {
        item.querySelector(`.quantity__input`).value = 0;
        item.querySelector('quantity-selector').previousQtyValue = 0
      }
    });
  }
});